class CodeTextEnum {
  constructor(value, code, text, table) {
    this.code = code
    this.value = value
    this.text = text
    this.table = table
  }
}

//取引先区分
const mtrdcompEnum = Object.freeze({
  enum_1: new CodeTextEnum('取引先CD', '取引先', '取引先選択', '取引先マスタ'),
  enum_2: new CodeTextEnum('得意先CD', '得意先', '得意先選択', '取引先マスタ'),
  enum_3: new CodeTextEnum(
    '協力会社CD',
    '協力会社',
    '協力会社選択',
    '取引先マスタ'
  ),
  enum_4: new CodeTextEnum(
    '点検組織CD',
    '点検組織',
    '点検組織選択',
    '取引先マスタ'
  ),
  enum_5: new CodeTextEnum('発注先CD', '発注先', '発注先選択', '取引先マスタ'),
  enum_6: new CodeTextEnum(
    '請求書送付先CD',
    '請求書送付先',
    '請求書送付先選択',
    '取引先マスタ'
  ),
  enum_7: new CodeTextEnum(
    '産廃業者CD',
    '産廃業者',
    '産廃業者選択',
    '取引先マスタ'
  ),
  enum_8: new CodeTextEnum('支払先CD', '支払先', '支払先選択', '取引先マスタ'),
})

//組織名称マスタ
const morgnznpEnum = Object.freeze({
  enum_1: new CodeTextEnum('部門CD', '部門', '部門選択', '組織名称マスタ'),
  enum_2: new CodeTextEnum(
    '計上部門CD',
    '計上部門',
    '計上部門選択',
    '組織名称マスタ'
  ),
  enum_3: new CodeTextEnum(
    '進行部門CD',
    '進行部門',
    '進行部門選択',
    '組織名称マスタ'
  ),
  enum_4: new CodeTextEnum(
    '入力部門CD',
    '入力部門',
    '入力部門選択',
    '組織名称マスタ'
  ),
  enum_5: new CodeTextEnum(
    '依頼部門CD',
    '依頼部門',
    '依頼部門選択',
    '組織名称マスタ'
  ),
  enum_6: new CodeTextEnum(
    '連絡先部門住所',
    '連絡先部門住所',
    '連絡先部門住所選択',
    '組織名称マスタ'
  ),
})

//統合全社員マスタ
const integratedEmployeesEnum = Object.freeze({
  enum_1: new CodeTextEnum(
    '担当者CD',
    '担当者',
    '担当者選択',
    '統合全社員マスタ'
  ),
  enum_2: new CodeTextEnum('計上担当者CD', '計上担当者', '計上担当者選択'),
  enum_3: new CodeTextEnum(
    '主任・監理技術者CD',
    '主任・監理技術者',
    '主任・監理技術者選択',
    '統合全社員マスタ'
  ),
  enum_4: new CodeTextEnum(
    '承認者CD',
    '承認者',
    '承認者選択',
    '統合全社員マスタ'
  ),
  enum_5: new CodeTextEnum(
    '支店長代理CD',
    '支店長代理',
    '支店長代理選択',
    '統合全社員マスタ'
  ),
  enum_6: new CodeTextEnum(
    '担当LCCD',
    '担当LC',
    '担当LC選択',
    '統合全社員マスタ'
  ),
  enum_7: new CodeTextEnum(
    '進行担当者CD',
    '進行担当者',
    '進行担当者選択',
    '統合全社員マスタ'
  ),
  enum_8: new CodeTextEnum(
    '発注者CD',
    '発注者',
    '発注者選択',
    '統合全社員マスタ'
  ),
  enum_9: new CodeTextEnum(
    '調査者CD',
    '調査者',
    '調査者選択',
    '統合全社員マスタ'
  ),
  enum_10: new CodeTextEnum(
    '依頼者CD',
    '依頼者',
    '依頼者選択',
    '統合全社員マスタ'
  ),
  enum_11: new CodeTextEnum(
    '送信先社員CD',
    '送信先社員',
    '送信先社員選択',
    '統合全社員マスタ'
  ),
  enum_12: new CodeTextEnum(
    '原価承認者CD',
    '原価承認者',
    '原価承認者選択',
    '承認者クラス管理'
  ),
  enum_13: new CodeTextEnum(
    '売価承認者CD',
    '売価見積承認者',
    '売価承認者選択',
    '統合全社員マスタ'
  ),
  enum_14: new CodeTextEnum(
    '受注担当者(計画)CD',
    '受注担当者(計画)',
    '受注担当者(計画)選択',
    '統合全社員マスタ'
  ),
  enum_15: new CodeTextEnum(
    '診断担当者(管理)CD',
    '診断担当者(管理)',
    '診断担当者(管理)選択',
    '統合全社員マスタ'
  ),
  enum_16: new CodeTextEnum(
    '管理担当者CD',
    '管理担当者',
    '管理担当者選択',
    '統合全社員マスタ'
  ),
  enum_17: new CodeTextEnum(
    '管理担当者CD',
    '管理担当者',
    '推進担当者選択',
    '統合全社員マスタ'
  ),
  enum_18: new CodeTextEnum('社員CD', '社員', '社員選択', '統合全社員マスタ'),
  enum_19: new CodeTextEnum(
    '作業予定者CD',
    '作業予定者',
    '作業予定者選択',
    '統合全社員マスタ'
  ),
  enum_20: new CodeTextEnum(
    '作業実施者CD',
    '作業実施者',
    '作業実施者選択',
    '統合全社員マスタ'
  ),
  enum_21: new CodeTextEnum(
    '作業立会者CD',
    '作業立会者',
    '作業立会者選択',
    '統合全社員マスタ'
  ),
  enum_22: new CodeTextEnum(
    '管理（推進）担当者CD',
    '管理（推進）担当者',
    '管理（推進）担当者選択',
    '統合全社員マスタ'
  ),
  enum_23: new CodeTextEnum(
    '送信先社員CD',
    '送信先社員',
    '送信先社員選択',
    '全社員マスタ'
  ),
  enum_24: new CodeTextEnum(
    '計画担当者',
    '計画担当者',
    '計画担当者選択',
    '全社員マスタ'
  ),
  enum_25: new CodeTextEnum(
    '監理担当者',
    '監理担当者',
    '監理担当者選択',
    '全社員マスタ'
  ),
  enum_26: new CodeTextEnum(
    '見積承認者CD',
    '見積承認者',
    '見積承認者選択',
    '統合全社員マスタ'
  ),
  enum_27: new CodeTextEnum(
    '監理担当者（副）',
    '監理担当者（副）',
    '監理担当者（副）選択',
    '全社員マスタ'
  ),
  enum_28: new CodeTextEnum(
    '原価承認者CD',
    '原価見積承認者',
    '原価承認者選択',
    '統合全社員マスタ'
  ),
})
//出精値引区分
const estrusListEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '出精値引10%'),
  enum_2: new CodeTextEnum('2', 'enum_2', '出精値引8%'),
})

//ページ
const pageViewEnum = Object.freeze({
  view: new CodeTextEnum('1', 'view', '照会'),
  update: new CodeTextEnum('2', 'update', '変更'),
  add: new CodeTextEnum('3', 'add', '登録'),
  copy: new CodeTextEnum('4', 'copy', '複製'),
})

//予定額項目区分
const expectedAmountItemEnum = Object.freeze({
  salesAmount: new CodeTextEnum(1, 'salesAmount', '売上額'),
  costAmount: new CodeTextEnum(2, 'costAmount', '原価額'),
})

// 工事記録簿一覧登録ボタン
const projectRecordBookCreatbuttonEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '受注確認'),
  enum_2: new CodeTextEnum('2', 'enum_2', '受注締結'),
  enum_3: new CodeTextEnum('3', 'enum_3', '下請締結'),
  enum_4: new CodeTextEnum('4', 'enum_4', '下請完了書類'),
})

// 調査内容区分
const investigationContentEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'アスベスト含調査'),
  enum_2: new CodeTextEnum('2', 'enum_2', '給排水管調査診断'),
  enum_3: new CodeTextEnum('3', 'enum_3', '建物調査診断'),
  enum_4: new CodeTextEnum('4', 'enum_4', '電気設備調査診断'),
  enum_5: new CodeTextEnum('5', 'enum_5', 'その他調査診断'),
})

//契約'契約期間
const contractPeriodEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '契約期間'),
  enum_2: new CodeTextEnum('2', 'enum_2', '納品予定年月'),
})
//通知先
const notifyTypeEnum = Object.freeze({
  work: new CodeTextEnum('work', 'work', '協力会社'),
  dln: new CodeTextEnum('dln', 'dln', '社内'),
})

//税率区分
const taxrtListEnum = Object.freeze({
  enum_1: new CodeTextEnum(0.1, 'enum_1', '10%'),
  enum_2: new CodeTextEnum(0.08, 'enum_2', '8%'),
})

// 一括区分
const allTogetherEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '一括'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', ' '),
})

//書類区分
const bookTypeEnum = Object.freeze({
  document: new CodeTextEnum('documents', 'documents', '書類提出'),
  report: new CodeTextEnum('report', 'report', '報告書提出'),
})

//

const estimateActionModeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '登録モード'),
  enum_2: new CodeTextEnum('2', 'enum_2', '変更モード'),
  enum_3: new CodeTextEnum('3', 'enum_3', '照会モード'),
  enum_4: new CodeTextEnum('4', 'enum_4', '原価のみ変更モード'),
  enum_5: new CodeTextEnum('5', 'enum_5', '見積のみ変更モード'),
})

const constructionRecordPurOrderTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '下請締結'),
  enum_2: new CodeTextEnum('2', 'enum_2', '下請完了書類'),
})

const constructionRecordApprovalModeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '受注確認登録モード'),
  enum_2: new CodeTextEnum('2', 'enum_2', '受注締結登録モード'),
  enum_3: new CodeTextEnum('3', 'enum_3', '完了報告書登録モード'),
  enum_4: new CodeTextEnum('4', 'enum_4', '保証書登録モード'),
  enum_5: new CodeTextEnum('5', 'enum_5', '組合完了確認書登録モード'),
})

const mitmdtlpModeEnum = Object.freeze({
  enum_1: new CodeTextEnum(
    '商品明細CD',
    '商品明細',
    '商品明細選択',
    '商品明細マスタ'
  ),
  enum_2: new CodeTextEnum(
    '商品明細CD',
    '組合直発注作業名',
    '商品明細選択',
    '商品明細マスタ'
  ),
})

//
const constructionRecordApprovalActionModeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '申請取消'),
  enum_2: new CodeTextEnum('2', 'enum_2', '承認取下'),
  enum_3: new CodeTextEnum('3', 'enum_3', '承認差戻'),
})

//書類フォルダー
const eFileDirectoryEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '見積書類フォルダー'),
  enum_2: new CodeTextEnum('2', 'enum_2', '受注書類フォルダー'),
  enum_3: new CodeTextEnum('3', 'enum_3', '発注書類フォルダー'),
  enum_4: new CodeTextEnum('4', 'enum_4', '納品書類フォルダー'),
  enum_5: new CodeTextEnum('5', 'enum_5', '電子契約フォルダー'),
})

module.exports = {
  //取引先選択区分
  mtrdcompEnum,
  //部門選択区分
  morgnznpEnum,
  //
  pageViewEnum,
  // 出精値引区分
  estrusListEnum,
  //予定額項目区分
  expectedAmountItemEnum,
  //統合全社員
  integratedEmployeesEnum,
  mitmdtlpModeEnum,
  // 工事記録簿一覧登録ボタン
  projectRecordBookCreatbuttonEnum,
  //調査内容区分
  investigationContentEnum,
  contractPeriodEnum,
  notifyTypeEnum,
  //税率区分
  taxrtListEnum,
  allTogetherEnum,
  bookTypeEnum,
  estimateActionModeEnum,
  constructionRecordPurOrderTypeEnum,
  constructionRecordApprovalModeEnum,
  constructionRecordApprovalActionModeEnum,
  //書類フォルダー
  eFileDirectoryEnum,
}
